import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=4ab8608c&scoped=true&"
import script from "./cabinet.vue?vue&type=script&lang=js&"
export * from "./cabinet.vue?vue&type=script&lang=js&"
import style0 from "./cabinet.vue?vue&type=style&index=0&id=4ab8608c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab8608c",
  null
  
)

export default component.exports